<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">Inspection Settings</span>
    <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>
  <div class="ttmodal__body ttmodal__sp">
    <div class="spinner" *ngIf="loading">
      <mat-spinner> </mat-spinner>
    </div>
    <div class="maindiv">
      <div *ngFor="let item of UCComponentInspectionOrderList" style="background-color: white; padding-bottom: 10px;">
        <div class="dropzone"
             draggable="true"
             (dragstart)="drag($event)"
             (drop)="drop($event)"
             (dragover)="allowDrop($event)"
             attr.id="{{item.ID}}"
             >
          <div style="display: flex; flex-direction: row; align-items: center; justify-content:space-between;">
            <div class="left">
              <div class="comparttype">{{item.ComponentType}}</div>
              <div class="arrows" *ngIf="!showMeasurementCounts">

                <span title="Move up"
                      [class.button-hide]="item.SortOrder==1?true:false"
                      (click)="recalculateSortOrder(item.ID, item.SortOrder, -1)">
                  <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_upward</i>
                </span>
                <span title="Move down"
                      [class.button-hide]="item.SortOrder>UCComponentInspectionOrderList.length-1?true:false"
                      (click)="recalculateSortOrder(item.ID, item.SortOrder, 1)">
                  <i class="material-icons" style="font-weight: bolder;font-size: 33px;">arrow_downward</i>
                </span>

              </div>

              <div class="reverse" *ngIf="item.ComponentTypeId == 235 && !showMeasurementCounts">
                <div class="comparttype">Inspect In Reverse</div>
                <div style="padding-left: 10px;">
                  <mat-checkbox [checked]="item.InspectInReverse" (change)="setInspectInRevrseFlag(item.ID, $event)"></mat-checkbox>
                </div>
              </div>

            </div>

            <div class="right" *ngIf="showMeasurementCounts" >
              
                <input type="number" (input)="setMeasurementCounts(item.ID, $event)" matInput [(ngModel)]="item.MeasurementCounts">
           
            </div>
        
          </div>

        </div>
       </div>
      </div>
  </div>
  <div class="ttmodal__footer divrightcontent">
    <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Close</span></a>
  </div>
</div>


